// extracted by mini-css-extract-plugin
module.exports = {"t1omnzjl":"t1omnzjl"};